// gtm-events.js
window.dataLayer = window.dataLayer || [];

 function getParamFromURL(param, _url){
      if(!_url) _url = window.location.href;
  
      var url = new URL(_url);
      var search_params = url.searchParams;
      var paramVal = search_params.get(param);
  
      return paramVal;
}

function deleteParamFromURL(param, _url){
      if(!param) return null;
      if(!_url) _url = window.location.href;
      var url = new URL(_url);
      var search_params = url.searchParams;
      search_params.delete(param);
      var new_url = url.toString();
      return new_url;
}

function _debounce(func, wait) {
  let timeout;

  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

class AlteregoAnalytics {
  constructor() {
    this.isMobile = window.innerWidth < 768;

    this.lastDesktopMenuInteractionTime = 0;

    this.trackScroll();
    this.trackMobileMenubarInteractionV2();
    this.trackKlaviyoNewsletterSubscription();
    this.trackCartQuantityChange();
    this.trackPDPYouMayAlsoLikeInteraction();
    this.trackPDPReviewPaginationInteraction();
    this.trackLoginAndSignup();
    this.trackHomepageBannerView();
    this.trackPLPSubCollectionAndPaginationInteraction();
    this.trackPLPAddToCart();
    this.trackBuyWithShop();
  }

  // 25%, 50%, 75%, 100% :: Debounce 100ms
  trackScroll() {
    let lastScrollTime = Date.now();
    window.addEventListener('scroll', _debounce(() => {
      const currentTime = Date.now();
      if(currentTime - lastScrollTime < 1000) return;
      lastScrollTime = currentTime;

      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollPercentage = (scrollPosition / (documentHeight - windowHeight)) * 100;
      let finalPercentage = 0;
      
      if (scrollPercentage >= 25 && scrollPercentage < 50) {
        finalPercentage = 25;
      }
      if (scrollPercentage >= 50 && scrollPercentage < 75) {
        finalPercentage = 50;
      }
      if (scrollPercentage >= 75 && scrollPercentage < 100) {
        finalPercentage = 75;
      }
      if (scrollPercentage >= 90) {
        finalPercentage = 90;
      }

      if(finalPercentage > 0) {
        Shopify.analytics.publish('on_page_scroll', {
          scroll_percent: finalPercentage,
        });
      }
    }, 1000));
  }

  // Track desktop menubar interaction v3 :: track clicks :: Global
  trackDesktopMainMenuInteraction(mainMenuTitle, subMenuTitle = '', interectionTime) {
    if(!mainMenuTitle) return;

    if(interectionTime - this.lastDesktopMenuInteractionTime < 250) return;

    this.lastDesktopMenuInteractionTime = interectionTime;

    Shopify.analytics.publish('on_desktop_menubar_interaction', {
      menu_section: mainMenuTitle,
      submenu_section: subMenuTitle,
      is_mobile: this.isMobile,
    });
  }

  // mobile menubar interaction v2 :: event delegation :: track clicks
  trackMobileMenubarInteractionV2() {
    const mobileMenuLinks = document.querySelectorAll('custom-header header [data-mobile-menu] .mobile-nav__list a');
    const hamburgerTrigger = document.querySelector('custom-header header [data-mobile-menu-trigger]');

    if (hamburgerTrigger) {
      hamburgerTrigger.addEventListener('click', () => {
        Shopify.analytics.publish('on_mobile_menubar_interaction', {
          menu_section: 'hamburger',
          submenu_section: '',
        });
      });
    }

    if (mobileMenuLinks.length === 0) return;

    mobileMenuLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault(); // Stop for a while

        let parentMenuName = '', childMenuName = '';
        const megaMenuContainer = link.closest('.mobile-mega-menu');
        if (megaMenuContainer) {
          parentMenuName = megaMenuContainer.closest('.mobile-nav__item')?.querySelector('.mobile-nav__link')?.textContent?.trim() || '';
          childMenuName = link?.querySelector('.mobile-mega-menu__title')?.textContent?.trim() || '';
        } else {
          parentMenuName = link?.textContent?.trim() || '';
          childMenuName = '';
        }
      
        Shopify.analytics.publish('on_mobile_menubar_interaction', {
          menu_section: parentMenuName,
          submenu_section: childMenuName,
        });

        // Redirect to the target URL after 250ms
        const targetUrl = link.href;
        if (targetUrl) {
          setTimeout(() => {
            window.location.href = targetUrl;
          }, 250);
        }
      });
    });
  }

  // track klaviyo newsletter subscription :: form submission :: trigger on last step of form submission
  // Steps: 1. stepSubmit, 2. submit, 3. viewedStep
  trackKlaviyoNewsletterSubscription() {
    let stepEvents = {
      Preferences: false,
      Email: false,
      Phone: false,
    };

    window.addEventListener("klaviyoForms", function(e) { 
      if(e?.detail?.type === "stepSubmit") {
        if(e?.detail?.metaData?.$step_name === "Preferences") {
          stepEvents.Preferences = true;
        }
        if(e?.detail?.metaData?.$step_name.includes("Email")) {
          stepEvents.Email = true;
        }
        if(e?.detail?.metaData?.$step_name === "Phone") {
          stepEvents.Phone = true;
        }
      }

      if(e?.detail?.type === "submit") {
        if(stepEvents.Preferences && stepEvents.Email && stepEvents.Phone) {
          Shopify.analytics.publish('on_newsletter_subscribe');
        }
      }
    });
  }

  // Track PLP Sort By Interaction
  trackSortByInteraction(value) {
    Shopify.analytics.publish('on_plp_filter_sort_by_interaction', {
      type: 'sort_by',
      plp_section: "Sort By",
      plp_subsection: value,
      is_mobile: this.isMobile,
      page_title: document.title,
    });
  }

  // Track PLP Filter Interaction
  trackFilterInteraction(parentFilterName, childFilterName, isFilterDrawer) {
    if(!parentFilterName) return;

    if(isFilterDrawer) {
      Shopify.analytics.publish('on_plp_filter_sort_by_interaction', {
        type: 'filter',
        plp_section: parentFilterName,
        plp_subsection: childFilterName,
        is_mobile: this.isMobile,
        page_title: document.title,
      });
    } else {
      Shopify.analytics.publish('on_plp_filter_sort_by_interaction', {
        type: 'sub_collection',
        plp_section: "Sub collection",
        plp_subsection: childFilterName,
        is_mobile: this.isMobile,
        page_title: document.title,
      });
    }
  }

  // Track PLP Sub-collection & Pagination Interaction
  trackPLPSubCollectionAndPaginationInteraction() {
    const collectionPage = document.querySelector('body.template-collection');
    if(!collectionPage) return;

    const subCollectionLinks = collectionPage.querySelectorAll('.subcollection_grid a');
    const paginationPageParam = getParamFromURL('page');
    if(paginationPageParam && paginationPageParam != '1' && !window.isNaN(paginationPageParam)) {
      Shopify.analytics.publish('on_plp_filter_sort_by_interaction', {
        type: 'pagination',
        plp_section: "Pagination",
        plp_subsection: paginationPageParam,
        is_mobile: this.isMobile,
        page_title: document.title,
      });
    }

    // Track sub-collection links
    subCollectionLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault(); // Stop for a while

        Shopify.analytics.publish('on_plp_filter_sort_by_interaction', {
          type: 'sub_collection',
          plp_section: "Sub collection",
          plp_subsection: link.querySelector('.collection-item__title')?.textContent?.trim(),
          is_mobile: this.isMobile,
          page_title: document.title,
        });

        // Redirect to the target URL after 250ms
        const targetUrl = link.href;
        if (targetUrl) {
          setTimeout(() => {
            window.location.href = targetUrl;
          }, 250);
        }
      });
    });
  }

  // Track PLP add to cart interaction
  trackPLPAddToCart() {
    document.addEventListener('click', (event) => {
      const addToCartButton = event.target.closest('.product-collection-showcase__card-add-to-cart, .hero-product-showcase__card-add-to-cart');
      if (!addToCartButton) return;

      const productTitle = addToCartButton.getAttribute('data-product-title') || '';
      const pageTitle = document.head?.querySelector('title')?.textContent?.trim() || document.title || '';

      Shopify.analytics.publish('plp_atc', {
        event: 'plp_atc',
        product_name: productTitle,
        page_title: pageTitle,
      });
    }, true);
  }

  // Track Buy with Shop button interaction
  trackBuyWithShop() {
    document.addEventListener('click', (event) => {
      const shopPayButton = event.target.closest('.shopify-payment-button');
      if (!shopPayButton) return;

      const productName = window._theme?.productJson?.title
        || document.querySelector('.product-single__title')?.textContent?.trim()
        || document.querySelector('h1.product__title')?.textContent?.trim()
        || '';

      Shopify.analytics.publish('buy_with_shop', {
        event: 'buy_with_shop',
        product_name: productName,
      });
    }, true);
  }

  // Track cart quantity change
  trackCartQuantityChange() {
    // Side cart quantity change
    document.addEventListener('cart:quantity.cart-cart-drawer', evt => {
      Shopify.analytics.publish('on_cart_quantity_change', {
        product_name: evt.detail[2]?.closest('.cart__item-details')?.querySelector('.cart__item-name')?.textContent?.trim(),
        product_quantity: evt.detail[1],
      });
    });

    // Cart page quantity change
    document.addEventListener('cart:quantity.cart-page', evt => {
      Shopify.analytics.publish('on_cart_quantity_change', {
        product_name: evt.detail[2]?.closest('.cart__item-details')?.querySelector('.cart__item-name')?.textContent?.trim(),
        product_quantity: evt.detail[1],
      });
    });
  }

  // Track PDP "You may also like" interaction
  trackPDPYouMayAlsoLikeInteraction() {
    const youMayAlsoLike = document.querySelector('body.template-product product-recommendations .grid-overflow-wrapper');
    if (!youMayAlsoLike || !window._theme?.productJson) return;

    youMayAlsoLike.addEventListener('click', (event) => {
      if(event.target.tagName != 'A' || !event.target.classList.contains('grid-product__link')) return;
      event.preventDefault(); // Stop for a while

      Shopify.analytics.publish('on_pdp_you_may_also_like_interaction', {
        from_sku: window._theme?.productJson?.title,
        to_sku: event.target.querySelector('.grid-product__title')?.textContent?.trim() || '',      
      });

      // Redirect to the target URL after 250ms
      const targetUrl = event.target.href;
      if (targetUrl) {
        setTimeout(() => {
          window.location.href = targetUrl;
        }, 250);
      }
    });
  }

  // Track PDP "Judjeme Reviews Pagination" interaction
  trackPDPReviewPaginationInteraction() {
    const reviewPagination = document.querySelector('body.template-product .jdgm-paginate');
    if (!reviewPagination || !window._theme?.productJson) return;

    reviewPagination.addEventListener('click', (event) => {
      const paginateCount = event.target.dataset?.page || 0;

      Shopify.analytics.publish('on_pdp_review_pagination_interaction', {
        pagination: paginateCount,
        from_product: window._theme?.productJson?.title,      
      });
    });
  }

  // Track Login & Signup
  trackLoginAndSignup() {
    const loginParam = getParamFromURL('login');
    const signUpParam = getParamFromURL('signup');

    if (signUpParam === 'true') {
      Shopify.analytics.publish('on_signup', {
        event: "signup",
        method: "email",
        user_id: window.ShopifyCustomerId || 'unknown',
      });
    }

    if (loginParam === 'true') {
      Shopify.analytics.publish('on_login', {
        event: "login",
        method: "email",
        user_id: window.ShopifyCustomerId || 'unknown',
      });
    }

    if (loginParam || signUpParam) {
      const newUrl = deleteParamFromURL('login', window.location.href);
      const finalUrl = deleteParamFromURL('signup', newUrl);
      window.history.replaceState({}, document.title, finalUrl);
    }
  }

  // Track Homepage Hero Banner View
  trackHomepageBannerView() {
    const banners = document.querySelectorAll(".hero__slide-link, .hero-banner__grid");
    banners && banners.length > 0 && banners.forEach((banner) => {
      // Track clicks
      banner.addEventListener("click", () => {
        trackBannerView('banner_click', banner);
      });

      // Track visible banners only
      const slide = banner.closest(".slideshow__slide, .hero-banner");
      if (!slide) return;

      let bannerTracked = false; // Prevent duplicate tracking

      if (slide.classList.contains("is-selected") && !bannerTracked) {
        trackBannerView('banner_view', banner);
        bannerTracked = true;
      }

      // Observe if the banner becomes active later
      const observer = new MutationObserver(() => {
        if (slide.classList.contains("is-selected") && !bannerTracked) {
          trackBannerView('banner_view', banner);
          bannerTracked = true;
          observer.disconnect(); // stop observing once tracked
        }else if (!bannerTracked) {
          trackBannerView('banner_view', banner);
          bannerTracked = true;
          observer.disconnect(); // stop observing once tracked
        }
      });

      observer.observe(slide, { attributes: true, attributeFilter: ["class"] });
    });

    function bindBannerTracking(selector, options = {}) {
      const root = options.root || document;
      const banners = root.querySelectorAll(selector);
      if (!banners || banners.length === 0) return;
      const bindKey = (options.bindKey || selector).replace(/[^a-zA-Z0-9_-]/g, "_");
      const clickBoundAttr = `data-analytics-click-bound-${bindKey}`;
      const viewBoundAttr = `data-analytics-view-bound-${bindKey}`;

      const observerIns = typeof IntersectionObserver !== "undefined"
        ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const trackViewOnce = entry.target.__trackBannerViewOnce;
            if (typeof trackViewOnce === "function") {
              trackViewOnce();
            }
            observerIns.unobserve(entry.target);
          });
        }, { threshold: 0.35 })
        : null;

      // Helper function to attach click event and optional view observer
      const addEventAndObserve = (el, event, callback, observe = true) => {
        if (!el) return;
        el.addEventListener(event, callback);
        if (observe && observerIns) {
          observerIns.observe(el);
        }
      };

      banners.forEach((banner, index) => {
        const indexValue = banner.getAttribute("data-banner-position") || (Number.isInteger(index) ? (index + 1) : "");
        const sectionValue = typeof options.getSectionName === "function"
          ? options.getSectionName(banner)
          : undefined;
        const observeTarget = typeof options.getObserveTarget === "function"
          ? options.getObserveTarget(banner)
          : banner;
        let viewTracked = false;

        const trackClick = () => {
          trackBannerView("banner_click", banner, sectionValue, indexValue);
        };

        const trackViewOnce = () => {
          if (viewTracked) return;
          trackBannerView("banner_view", banner, sectionValue, indexValue);
          viewTracked = true;
        };

        if (!banner.hasAttribute(clickBoundAttr)) {
          addEventAndObserve(banner, "click", trackClick, false);
          banner.setAttribute(clickBoundAttr, "true");
        }

        if (observerIns && observeTarget && !observeTarget.hasAttribute(viewBoundAttr)) {
          // Keep callback reference on the element so shared observer can invoke it.
          observeTarget.__trackBannerViewOnce = trackViewOnce;
          observerIns.observe(observeTarget);
          observeTarget.setAttribute(viewBoundAttr, "true");
        }
      });
    }

    const refreshDynamicBannerTracking = (root = document) => {
      bindBannerTracking(".ctab__card", {
        root,
        bindKey: "ctab-card",
        getObserveTarget: (banner) => banner.closest(".swiper-slide") || banner,
      });
      bindBannerTracking(".hero-product-showcase__container", {
        root,
        bindKey: "hero-product-showcase",
        getObserveTarget: (banner) => banner.closest(".hero-product-showcase__section") || banner,
      });
      bindBannerTracking("[data-product-collection-showcase-section] .product-collection-showcase__card", {
        root,
        bindKey: "product-collection-showcase",
        getSectionName: (banner) => banner.closest("[data-product-collection-swiper]")?.getAttribute("data-section-name") || "",
        getObserveTarget: (banner) => banner.closest(".swiper-slide") || banner,
      });
      bindBannerTracking(".hat-fits__card", {
        root,
        bindKey: "hat-fits",
        getObserveTarget: (banner) => banner.closest(".swiper-slide") || banner,
      });
      bindBannerTracking(".alter-ego-lifestyle__card", {
        root,
        bindKey: "alter-ego-lifestyle",
        getObserveTarget: (banner) => banner.closest(".swiper-slide") || banner,
      });
      bindBannerTracking(".auto-scroll-products__product-card", {
        root,
        bindKey: "auto-scroll-products",
        getObserveTarget: (banner) => banner.closest(".swiper-slide") || banner,
      });
      bindBannerTracking(".testimonials__slide", {
        root,
        bindKey: "testimonials",
        getObserveTarget: (banner) => banner.closest(".swiper-slide") || banner,
      });
    };

    this.refreshDynamicBannerTracking = refreshDynamicBannerTracking;
    refreshDynamicBannerTracking(document);

    document.addEventListener("product-collection-showcase:initialized", (event) => {
      const sectionRoot = event?.detail?.section;
      refreshDynamicBannerTracking(sectionRoot || document);
    });

    function trackBannerView(eventName, banner, sectionName, index) {
      if(!banner) return;
  
      const bannerName = banner.getAttribute("data-banner-name") || "unknown_banner";
      const bannerPosition = Number.isInteger(index) ? index : (banner.getAttribute("data-banner-position") || "");
      const sectionValue = sectionName || banner.getAttribute("data-section-name") || "";
      Shopify.analytics.publish(eventName, {
        banner_name: bannerName,
        banner_position: bannerPosition,
        section_name: sectionValue,
      });
    }
  }

}


document.addEventListener("DOMContentLoaded", function () {
  window.alteregoAnalytics = new AlteregoAnalytics();

  /* ----------------------- Search Tracking -------------------------*/
  function pushSearchSuccess(inputElement) {
    const searchTerm = inputElement?.value || "";
    if (!searchTerm.trim()) return;

    Shopify.analytics.publish('on_search_success', {
      event: "search_success",
      searchTerm: searchTerm,
    });

    // window.dataLayer.push({
    //   event: "search_success",
    //   search_term: searchTerm,
    // });
  }

  // Predictive search
  const predictiveForm = document.querySelector("form.ae-search-form");
  const predictiveResults = document.querySelector(".ae-predictive-search__results");

  if (predictiveForm && predictiveResults) {
    predictiveForm.addEventListener("submit", () => {
      pushSearchSuccess(predictiveForm.querySelector("input[type='search']"));
    });

    let predictiveSearchTracked = false;
    const observerPredictive = new MutationObserver(() => {
      if (!predictiveSearchTracked) {
        pushSearchSuccess(predictiveForm.querySelector("input[type='search']"));
        predictiveSearchTracked = true;
        
        // Reset tracking flag after 2 seconds to allow new searches
        setTimeout(() => {
          predictiveSearchTracked = false;
        }, 2000);
      }
    });

    observerPredictive.observe(predictiveResults, {
      childList: true,
      subtree: true
    });
  }

  // Search page
  const searchPageForm = document.querySelector("form[role='search']:not(.ae-search-form)");
  const searchPageResults = document.querySelector(".search__results");

  if (searchPageForm && searchPageResults) {
    searchPageForm.addEventListener("submit", () => {
      pushSearchSuccess(searchPageForm.querySelector("input[type='search']"));
    });

    let pageSearchTracked = false;
    const observerPage = new MutationObserver(() => {
      if (!pageSearchTracked) {
        pushSearchSuccess(searchPageForm.querySelector("input[type='search']"));
        pageSearchTracked = true;
        
        // Reset tracking flag after 2 seconds to allow new searches
        setTimeout(() => {
          pageSearchTracked = false;
        }, 2000);
      }
    });

    observerPage.observe(searchPageResults, {
      childList: true,
      subtree: true
    });
  }

  /* ----------------------- Cart Tracking -------------------------*/
  // Fixed cart tracking - prevents duplicate events and ensures data exists
  let cartViewTracked = false; // Prevent duplicate events

  // Cart state management
  function refreshCartState() {
    return fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        window.cartState = {
          totalItems: cart.item_count,
          totalValue: cart.total_price / 100,
          currency: cart.currency,
          items: cart.items.map(item => ({
            variantId: String(item.variant_id),
            productId: String(item.product_id),
            name: item.product_title,
            price: item.price / 100,
            quantity: item.quantity,
            sku: item.sku,
            vendor: item.vendor,
            product_type: item.product_type,
            variant_title: item.variant_title
          }))
        };
        
        return window.cartState;
      })
      .catch(err => {
        return null;
      });
  }

  // Cart view tracking function
  function trackCartView() {
    // Prevent duplicate tracking
    if (cartViewTracked) {
      return;
    }

    if (!window.cartState || !window.cartState.items || window.cartState.items.length === 0) {
      return;
    }

    const items = window.cartState.items.map((item, index) => ({
      index: index,
      item_id: item.sku || item.variantId,
      product_id: item.productId,
      variant_id: item.variantId,
      item_name: item.name + (item.sku ? ` - ${item.sku}` : ''),
      price: item.price,
      quantity: item.quantity,
      item_brand: item.vendor || '',
      item_category: item.product_type || '',
      item_variant: item.variant_title !== 'Default Title' ? item.variant_title : undefined,
      sku: item.sku
    }));

    Shopify.analytics.publish('on_sidecart_view', {
      event: "view_cart",
      ecommerce: {
        currency: window.cartState.currency,
        value: window.cartState.totalValue,
        items: items
      }
    });

    // window.dataLayer = window.dataLayer || [];
    // window.dataLayer.push({
    //   event: "view_cart",
    //   ecommerce: {
    //     currency: window.cartState.currency,
    //     value: window.cartState.totalValue,
    //     items: items
    //   }
    // });

    cartViewTracked = true;

    // Reset the flag after 2 seconds to allow tracking again
    setTimeout(() => {
      cartViewTracked = false;
    }, 2000);
  }

  // Listen to your theme's drawer events
  document.addEventListener('drawerOpen', function(event) {
    // Check if it's the cart drawer by looking for cart-related elements
    setTimeout(() => {
      const cartDrawer = document.querySelector('.drawer--is-open .cart__items, .drawer--is-open [data-cart-subtotal]');
      if (cartDrawer) {
        // Refresh cart state first, then track
        refreshCartState().then(() => {
          trackCartView();
        });
      }
    }, 100);
  });

  // Cart removal tracking
  document.addEventListener("click", function (e) {
    return;
    const removeBtn = e.target.closest(".cart__remove a");
    const minusBtn = e.target.closest(".js-qty__adjust--minus");

    if (!removeBtn && !minusBtn) return;

    let variantId = e.target.getAttribute("data-variant-id") || 
     e.target.closest("[data-variant-id]")?.getAttribute("data-variant-id");

    if (!variantId) {
      const cartItem = e.target.closest(".cart__item");
      const variantInput = cartItem?.querySelector("input.js-qty__num");
      variantId = variantInput?.getAttribute("data-id")?.split(":")[0] || "";
    }

    if (!variantId) return;

    const cartItemData = window.cartState?.items?.find(item => item.variantId == variantId);

    if (!cartItemData) {
      // Try to refresh cart state and retry
      refreshCartState().then(() => {
        const retryItemData = window.cartState?.items?.find(item => item.variantId == variantId);
        if (retryItemData) {
          pushRemovalEvent(retryItemData, removeBtn);
        }
      });
      return;
    }

    pushRemovalEvent(cartItemData, removeBtn);
  });

  // Helper function for removal event
  function pushRemovalEvent(cartItemData, isCompleteRemoval) {
    const removedQuantity = isCompleteRemoval ? cartItemData.quantity : 1;

    const removedItem = {
      item_id: cartItemData.sku || cartItemData.variantId,
      product_id: cartItemData.productId,
      variant_id: cartItemData.variantId,
      item_name: cartItemData.name + (cartItemData.sku ? ` - ${cartItemData.sku}` : ''),
      price: cartItemData.price,
      quantity: removedQuantity,
      item_brand: cartItemData.vendor || '',
      item_category: cartItemData.product_type || '',
      item_variant: cartItemData.variant_title !== 'Default Title' ? cartItemData.variant_title : undefined,
      sku: cartItemData.sku
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "remove_from_cart",
      ecommerce: {
        currency: "INR",
        value: cartItemData.price * removedQuantity,
        items: [removedItem]
      }
    });
  }

  function parseAnalyticsPrice(rawPrice) {
    if (rawPrice === null || rawPrice === undefined) return 0;
    const normalized = String(rawPrice).replace(/[^0-9.]/g, "");
    const parsed = Number.parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function getWishlistCard(wishlistElement) {
    return wishlistElement?.closest(
      ".product-collection-showcase__card, .hero-product-showcase__card, .featured-collection__card, .collection-grid__card, [data-product-handle], .product-single__meta"
    );
  }

  /** PDP root from `snippets/product-template.liquid` — holds handle, id, title */
  function getWishlistProductSection(card) {
    return card?.closest?.(".product-section") || null;
  }

  /** Strip nested Swym markup from PDP title when reading from the DOM. */
  function getProductSingleTitleClean(card) {
    const h1 = card?.querySelector?.(".product-single__title");
    if (!h1) return "";
    const clone = h1.cloneNode(true);
    clone.querySelector("#swym-custom-wishlist-button")?.remove();
    clone.querySelector(".swym-custom-pdp-button")?.remove();
    return clone.textContent.replace(/\s+/g, " ").trim();
  }

  /** Prefer selected variant on PDP (?variant= or form # id). */
  function getLivePdpVariantId(productSection) {
    if (!productSection?.matches?.(".product-section")) return "";
    const fromUrl = new URLSearchParams(window.location.search).get("variant");
    if (fromUrl && /^\d+$/.test(fromUrl)) return fromUrl;
    const idEl = productSection.querySelector('[name="id"]');
    const val = idEl && (idEl.value ?? idEl.getAttribute("value"));
    if (val && /^\d+$/.test(String(val))) return String(val);
    const invEl = productSection.querySelector(".variant-inventory-status[data-variant-id]");
    const invVid = invEl?.getAttribute("data-variant-id");
    return invVid && /^\d+$/.test(invVid) ? invVid : "";
  }

  function getWishlistEngineRoot(el) {
    if (!el) return null;
    return el.closest?.(".wishlist-engine") || (el.matches?.(".wishlist-engine") ? el : null);
  }

  function buildWishlistPayload(wishlistElement) {
    const card = getWishlistCard(wishlistElement);
    if (!card) return null;

    const productSection = getWishlistProductSection(card);
    const engine = getWishlistEngineRoot(wishlistElement);

    const title =
      card.querySelector(".product-collection-showcase__card-title a, .hero-product-showcase__card-title a")?.textContent?.trim()
      || productSection?.getAttribute("data-product-title")?.trim()
      || card.getAttribute("data-banner-name")
      || getProductSingleTitleClean(card)
      || "";

    const handle =
      card.getAttribute("data-product-handle")
      || productSection?.getAttribute("data-product-handle")
      || "";

    const fitName =
      card.querySelector(".product-single__vendor")?.textContent?.trim()
      || card.querySelector(".product-single__meta .product-single__vendor")?.textContent?.trim()
      || card.querySelector(".product-single__meta .custom_display_text")?.textContent?.trim()
      || card.querySelector(".custom_display_text")?.textContent?.trim()
      || card.querySelector(".product-collection-showcase__card-custom-title .custom_display_text")?.textContent?.trim()
      || card.querySelector(".hero-product-showcase__card-custom-title .custom_display_text")?.textContent?.trim()
      || "";

    const rawPrice =
      card.querySelector(".product-collection-showcase__card-price")?.getAttribute("data-product-price")
      || card.querySelector(".hero-product-showcase__card-price")?.getAttribute("data-product-price")
      || card.querySelector(".product-single__meta [data-product-single-price]")?.getAttribute("data-product-single-price")
      || card.querySelector("[data-product-single-price]")?.getAttribute("data-product-single-price")
      || card.querySelector("[data-product-price]")?.getAttribute("data-product-price")
      || card.querySelector(".product-collection-showcase__card-price")?.textContent?.trim()
      || card.querySelector(".hero-product-showcase__card-price")?.textContent?.trim()
      || card.querySelector(".product-single__meta .product__price")?.textContent?.trim()
      || "";
    const price = parseAnalyticsPrice(rawPrice);

    const btn = wishlistElement?.matches?.(".swym-wishlist-collections-v2")
      ? wishlistElement
      : wishlistElement?.querySelector?.(".swym-wishlist-collections-v2");

    let productId =
      card.getAttribute("data-product_id")
      || productSection?.getAttribute("data-product-id")
      || productSection?.querySelector('input[name="product-id"]')?.value?.trim()
      || card.querySelector(".jdgm-widget[data-id], .jdgm-preview-badge[data-id]")?.getAttribute("data-id")
      || "";
    let variantId = card.getAttribute("data-variant_id") || "";

    if (engine) {
      productId = productId || engine.getAttribute("data-product_id") || "";
      variantId = variantId || engine.getAttribute("data-variant_id") || "";
    }

    const liveVariantId = getLivePdpVariantId(productSection);
    if (liveVariantId) variantId = liveVariantId;

    if (btn) {
      const btnPid = btn.getAttribute("data-product-id") || btn.getAttribute("data-product_id") || "";
      const btnVid = btn.getAttribute("data-variant-id") || btn.getAttribute("data-variant_id") || "";
      if (/^\d+$/.test(String(btnPid))) productId = productId || btnPid;
      if (/^\d+$/.test(String(btnVid))) variantId = variantId || btnVid;
    }

    const currency = window.Shopify?.currency?.active || "USD";
    const itemId = variantId || productId || handle;

    return {
      currency,
      value: price,
      items: [
        {
          item_id: itemId,
          item_name: title,
          item_brand: "Alter Ego Running",
          item_category: fitName || '',
          price,
          quantity: 1
        }
      ]
    };
  }

  function pushWishlistEvent(eventName, wishlistElement) {
    const payload = buildWishlistPayload(wishlistElement);
    if (!payload || !payload.items?.length) return;
    Shopify.analytics.publish(eventName, {
      ecommerce: payload
    });
  }

  /** Wishlist control: Swym collections v2, Swym PDP custom (#swym-custom-wishlist-button), ATW, or SE Wishlist Engine */
  function getWishlistToggleButton(el) {
    if (!el) return null;
    if (el.matches?.(".swym-wishlist-collections-v2")) return el;
    if (el.matches?.("#swym-atw-pdp-button")) return el;
    if (el.matches?.(".wishlist-engine-button")) return el;
    if (el.matches?.("#swym-custom-wishlist-button")) return el.querySelector("button");
    if (el.matches?.(".swym-custom-pdp-button")) return el.querySelector("button");
    if (el.matches?.("#swym-atw-button-container")) return el.querySelector("#swym-atw-pdp-button");
    if (el.matches?.(".swym-wishlist-collections-v2-container")) {
      return el.querySelector(".swym-wishlist-collections-v2");
    }
    if (el.matches?.(".wishlist-engine")) return el.querySelector(".wishlist-engine-button") || el;

    const hit = el.closest?.(
      ".swym-wishlist-collections-v2, " +
      "#swym-custom-wishlist-button button, " +
      ".swym-custom-pdp-button button, " +
      "#swym-atw-pdp-button, " +
      ".wishlist-engine-button",
    );
    if (hit) return hit;
    const engine = el.closest?.(".wishlist-engine");
    return engine ? engine.querySelector(".wishlist-engine-button") || engine : null;
  }

  function resolveWishlistDomRoot(card, sourceWishlistElement) {
    const swCustom = sourceWishlistElement.closest?.("#swym-custom-wishlist-button");
    if (swCustom && card.contains(swCustom)) return swCustom;

    const atw = sourceWishlistElement.closest?.("#swym-atw-button-container");
    if (atw && card.contains(atw)) return atw;

    const engine = sourceWishlistElement.closest?.(".wishlist-engine");
    if (engine && card.contains(engine)) return engine;

    const coll = sourceWishlistElement.closest?.(".swym-wishlist-collections-v2-container");
    if (coll && card.contains(coll)) return coll;

    return (
      card.querySelector(".swym-wishlist-collections-v2-container")
      || swCustom
      || atw
      || engine
      || sourceWishlistElement.closest?.(".swym-wishlist-collections-v2-container")
      || sourceWishlistElement
    );
  }

  /**
   * Swym: aria-pressed / data-added on collections container; PDP custom uses same aria-pressed.
   * Wishlist Engine: data-added on .wishlist-engine or ancestors.
   */
  function getWishlistState(el) {
    const btn = getWishlistToggleButton(el);
    if (!btn) return null;

    const collectionsContainer = btn.closest?.(".swym-wishlist-collections-v2-container");
    if (collectionsContainer) {
      const addedOnContainer = collectionsContainer.getAttribute("data-added");
      if (addedOnContainer === "true" || addedOnContainer === "false") return addedOnContainer;
      const addedOnCollectionsBtn = btn.getAttribute("data-added");
      if (addedOnCollectionsBtn === "true" || addedOnCollectionsBtn === "false") return addedOnCollectionsBtn;
    }

    const pressed = btn.getAttribute("aria-pressed");
    if (pressed === "true" || pressed === "false") return pressed;

    const engine = btn.closest?.(".wishlist-engine");
    if (engine) {
      let node = engine;
      while (node) {
        const v = node.getAttribute?.("data-added");
        if (v === "true" || v === "false") return v;
        if (node.matches?.(".product-single__meta")) break;
        node = node.parentElement;
      }
    }

    const addedOnBtn = btn.getAttribute("data-added");
    if (addedOnBtn === "true" || addedOnBtn === "false") return addedOnBtn;

    return null;
  }

  function processWishlistInteraction(sourceWishlistElement) {
    const card = getWishlistCard(sourceWishlistElement);
    if (!card) return;

    const beforeState = getWishlistState(sourceWishlistElement);

    const resolveCurrentWishlistRoot = () => resolveWishlistDomRoot(card, sourceWishlistElement);

    let attempts = 0;
    const maxAttempts = 20;
    const interval = setInterval(() => {
      attempts += 1;
      const root = resolveCurrentWishlistRoot();
      const afterState = getWishlistState(root);

      if (afterState != null && beforeState !== afterState) {
        const eventName = afterState === "true" ? "product_add_to_wishlist" : "product_remove_from_wishlist";
        pushWishlistEvent(eventName, root || getWishlistToggleButton(root) || sourceWishlistElement);
        clearInterval(interval);
        return;
      }

      if (attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 150);
  }

  document.addEventListener("click", function (e) {
    const wishlistHit = e.target.closest(
      ".swym-wishlist-collections-v2, " +
      "#swym-custom-wishlist-button button, " +
      ".swym-custom-pdp-button button, " +
      "#swym-atw-pdp-button, " +
      ".wishlist-engine-button",
    );
    if (wishlistHit) {
      processWishlistInteraction(wishlistHit);
      return;
    }
    const engineRoot = e.target.closest(".wishlist-engine");
    if (engineRoot) processWishlistInteraction(engineRoot);
  }, true);

  // Initialize cart state on page load
  refreshCartState();

  // Update cart state when cart changes (for themes that dispatch custom events)
  document.addEventListener('cart:updated', refreshCartState);
  document.addEventListener('cart:refresh', refreshCartState);

  function callbackChatbotInteraction() {
    Shopify.analytics.publish('on_chatbot_interaction', {
      event: 'chatbot_interaction',
    });
    console.log('Chatbot opened');
  }

  const waitForGorgiasChat = setInterval(() => {
    // Prevent "GorgiasChat is not defined" error
    if (typeof window.GorgiasChat !== 'undefined' && window.GorgiasChat) {
      // Attach event only once
      window.GorgiasChat.on('widget:opened', callbackChatbotInteraction);

      clearInterval(waitForGorgiasChat);
    }
  }, 500);
});